<template>
  <layouts-header></layouts-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />
  <coach-settings-tabset></coach-settings-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-tabset></settings-tabset>
      <div class="row">
        <div class="col-sm-12">
          <div class="profile-detail-group">
            <div class="card">
              <form>
                <div class="row">
                  <div class="col-lg-7 col-md-7">
                    <div class="input-space">
                      <label class="form-label">Old Password</label>
                      <input
                        type="text"
                        class="form-control"
                        id="password"
                        placeholder="Enter Old Password"
                      />
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-7">
                    <div class="input-space">
                      <label class="form-label">New Password</label>
                      <input
                        type="text"
                        class="form-control"
                        id="new-password"
                        placeholder="Enter New Password"
                      />
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-7">
                    <div class="input-space mb-0">
                      <label class="form-label">Confirm Password</label>
                      <input
                        type="text"
                        class="form-control"
                        id="confirm-password"
                        placeholder="Enter Confirm Password"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="save-changes text-end">
              <a href="javascript:;" class="btn btn-primary reset-profile">Reset</a>
              <a href="javascript:;" class="btn btn-secondary save-profile"
                >Save Change</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
export default {
  data() {
    return {
      title: "Change Password",
      text: "Home",
      text1: "Change Password",
    };
  },
};
</script>
